/**
 * The base resolution of the timeline - everything
 * stems from this!
 */
export const DAY_RESOLUTION_PX = 3

export const TIMELINE_PRODUCT_ROW_HEIGHT_PX = 72
export const TIMELINE_PHASE_ROW_HEIGHT_PX = 32
/** The offset of the period from the actual date - for stylistic reasons */
export const BILLING_PERIOD_PILL_OFFSET_FROM_DATE_PX = 3
export const TIMELINE_WRAPPER_HEIGHT_PX = 392
export const TIMELINE_SCROLLBAR_HEIGHT_PX = 14
export const TIMELINE_AXIS_HEIGHT_PX = 48

/**
 * Other timeline behavioural gubbins
 */
export const TIMELINE_BUFFER_IN_YEARS = 3
export const TIMELINE_LINK_FADE_OFFSET = 150
/**
 * z-indexes
 */
export const TIMELINE_AXIS_Z_INDEX = 100
export const TIMELINE_DAY_INDICATORS_Z_INDEX = 110
export const TIMELINE_LINKS_Z_INDEX = 50
export const TIMELINE_LABELS_Z_INDEX = 49
export const TIMELINE_PHASE_MARKERS_Z_INDEX = 10
export const TIMELINE_DATA_SERIES_Z_INDEX = 1

/**
 * Date formatting constants
 */
export const TIMELINE_DATE_OFFSET_FORMAT = 'yyyyMMdd'
export const TIMELINE_DATE_PHASE_FORMAT = 'd LLLL yyyy'
